module.exports = __webpack_public_path__ + "img/alain_ducasse_at_morpheus.2ff3e95a.jpg";